<div [attr.aria-label]="'searchBox.productSearch' | cxTranslate" role="search">
  <label class="searchbox" [class.dirty]="!!searchInput.value">
    <input
      #searchInput
      [placeholder]="'searchBox.placeholder' | cxTranslate"
      autocomplete="off"
      aria-describedby="initialDescription"
      aria-controls="results"
      [attr.aria-label]="'searchBox.placeholder' | cxTranslate"
      (focus)="open()"
      (click)="open()"
      (input)="search(searchInput.value)"
      (blur)="forceClose()"
      (keydown.escape)="forceClose()"
      (keydown.enter)="
        forceClose();
        launchSearchResult(searchInput.value);
        updateChosenWord(searchInput.value)
      "
      (keydown.arrowup)="focusPreviousChild($any($event))"
      (keydown.arrowdown)="focusNextChild($any($event))"
      value="{{ chosenWord }}"
    />

    <button
      [attr.aria-label]="'common.reset' | cxTranslate"
      (mousedown)="clear(searchInput)"
      (keydown.enter)="clear(searchInput)"
      class="reset"
    >
      <cx-icon [type]="iconTypes.RESET"></cx-icon>
    </button>

    <div role="presentation" class="search-icon">
      <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
    </div>

    <button [attr.aria-label]="'common.search' | cxTranslate" class="search" (click)="open()">
      <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
    </button>
  </label>
</div>

<div *ngIf="results$ | async as result" class="results" id="results" (click)="forceClose()" role="dialog">
  <div *ngIf="result.message" class="message" [innerHTML]="result.message"></div>
  <!--RESULT  SUGGESTIONS-->
  <ng-container>
    <div class="message ml-3" *ngIf="result?.suggestions?.length">
      {{ 'searchBox.suggestions' | cxTranslate }}
    </div>
  </ng-container>
  <ul
    class="suggestions ui-widget pl-0"
    attr.aria-label="{{ 'searchBox.ariaLabelSuggestions' | cxTranslate }}"
    role="listbox"
  >
    <li *ngFor="let suggestion of result.suggestions" class="ui-menu-item">
      <a
        role="option"
        [innerHTML]="suggestion | cxHighlight: searchInput.value"
        [routerLink]="
          {
            cxRoute: 'search',
            params: { query: suggestion }
          } | cxUrl
        "
        (keydown.arrowup)="focusPreviousChild($any($event))"
        (keydown.arrowdown)="focusNextChild($any($event))"
        (keydown.enter)="forceClose()"
        (keydown.escape)="forceClose()"
        (blur)="forceClose()"
        (mousedown)="preventDefault($event)"
        (click)="
          dispatchSuggestionEvent({
            freeText: searchInput.value,
            selectedSuggestion: suggestion,
            searchSuggestions: result.suggestions ?? []
          });
          updateChosenWord(suggestion)
        "
      >
      </a>
    </li>
  </ul>

  <!--  RECENT SEARCHES-->
  <ng-container>
    <ng-template
      *ngIf="config.recentSearches"
      [cxOutlet]="searchBoxOutlets.RECENT_SEARCHES"
      [cxOutletContext]="{
        search: searchInput.value,
        searchBoxActive: searchBoxActive,
        maxRecentSearches: config.maxRecentSearches
      }"
    ></ng-template>
  </ng-container>

  <!--RESULT  PRODUCTS-->
  <ng-container>
    <div class="message ml-4" *ngIf="result.products?.length">
      {{ 'searchBox.products' | cxTranslate }}
    </div>
  </ng-container>
  <ul
    class="products ui-widget pl-0"
    *ngIf="result.products"
    attr.aria-label="{{ 'searchBox.ariaLabelProducts' | cxTranslate }}"
    role="listbox"
  >
    <li *ngFor="let product of result.products" class="ui-menu-item">
      <a
        role="option"
        [routerLink]="
          {
            cxRoute: 'product',
            params: product
          } | cxUrl
        "
        [class.has-media]="config.displayProductImages"
        (keydown.arrowup)="focusPreviousChild($any($event))"
        (keydown.arrowdown)="focusNextChild($any($event))"
        (keydown.enter)="forceClose()"
        (keydown.escape)="forceClose()"
        (blur)="forceClose()"
        (mousedown)="preventDefault($event)"
        (click)="
          dispatchProductEvent({
            freeText: searchInput.value,
            productCode: product.code
          })
        "
      >
        <div class="name">
          <div style="font-weight: bold">{{ product.code }}</div>
          <em class="search-results-highlight">{{ product.name }}</em>
        </div>
        <span class="price">{{ product.price?.formattedValue }}</span>
      </a>
    </li>
  </ul>
  <span id="initialDescription" class="cx-visually-hidden">
    {{ 'searchBox.initialDescription' | cxTranslate }}
  </span>
  <div *ngIf="result.suggestions?.length || result.products?.length" aria-live="assertive" class="cx-visually-hidden">
    {{ 'searchBox.suggestionsResult' | cxTranslate: { count: result.suggestions?.length } }}
    {{ 'searchBox.productsResult' | cxTranslate: { count: result.products?.length } }}
    {{ 'searchBox.initialDescription' | cxTranslate }}
  </div>
</div>
